import { render } from "./TrendingCourse.vue?vue&type=template&id=04a106b8&scoped=true"
import script from "./TrendingCourse.vue?vue&type=script&lang=js"
export * from "./TrendingCourse.vue?vue&type=script&lang=js"

import "./TrendingCourse.vue?vue&type=style&index=0&id=04a106b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a106b8"]])

export default __exports__